import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import type { User } from '@/configs/apis/user';
import ChatSettingDrawer from '@/components/chat-setting-drawer';
import GroupMemberList from '../group-member-list';
import styles from './index.module.scss';
// import AddIcon from './images/add.svg?react';

interface GroupSearchMembersProps {
  open: boolean;
  memberList: ChatGroupMember[];
  chat: Chat;
  user: User | null;
  onCancel: (showOpenGroupSetting?: boolean) => void;
  onActionOk?: () => void;
}
const GroupSearchMembers = ({
  open,
  memberList,
  chat,
  user,
  onCancel,
}: GroupSearchMembersProps) => {
  const [searchText, setSearchText] = useState<string>('');

  const data_ = useMemo(() => {
    return memberList?.filter((item) => item.name?.includes(searchText));
  }, [searchText, memberList]);

  const onSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  }, []);

  useEffect(() => {
    if (open) {
      setSearchText('');
    }
  }, [open]);

  return (
    <ChatSettingDrawer
      className={styles.groupSearchModal}
      open={open}
      text={`${memberList.length} Members`}
      onBack={onCancel}
      onCancel={onCancel}
    >
      <div className={styles.search}>
        <Input
          value={searchText}
          prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          variant="filled"
          placeholder="Search"
          onChange={onSearch}
        />
      </div>
      <div className={styles.content}>
        <GroupMemberList
          chat={chat}
          user={user}
          memberList={data_}
          onClick={onCancel}
        ></GroupMemberList>
      </div>
    </ChatSettingDrawer>
  );
};
export default GroupSearchMembers;
